import { Box, Center, Heading, SimpleGrid, Stack, Text } from '@chakra-ui/react';
import '@fontsource/manrope/400.css';
import '@fontsource/manrope/600.css';
import '@fontsource/manrope/800.css';
import { CheckboxContainer } from 'formik-chakra-ui';
import CreateProfileButton from '../CreateProfileButton';
import { FormStep } from '../MultiStepForm';

export default function Locations(props: {
    onSubmit: any;
    checkedLocations: any;
    handleLocationsCheckboxChange: any;
    formError: any;
    validationSchema: any;
}) {
    const { onSubmit, checkedLocations, formError, handleLocationsCheckboxChange, validationSchema } = props;
    const locations: string[] = [
        'Any City in the US',
        'Los Angeles',
        'San Francisco',
        'Chicago',
        'Seattle',
        'Austin',
        'Houston',
        'Philadelphia',
        'Remote',
        'New York City',
        'Boston',
        'Washington, DC',
        'Atlanta',
        'Phoenix',
        'Dallas',
        'Portland'
    ];
    // get first half of locations array
    const firstHalfOfLocations = locations.slice(0, locations.length / 2);
    const secondHalfOfLocations = locations.slice(locations.length / 2);
    const locationOptions1 = firstHalfOfLocations.map((location) => {
        return (
            <CreateProfileButton
                type="careers"
                name="locations"
                text={location}
                key={location}
                onChange={handleLocationsCheckboxChange}
                isChecked={checkedLocations.includes(location)}
            />
        );
    });

    const locationOptions2 = secondHalfOfLocations.map((location) => {
        return (
            <CreateProfileButton
                type="careers"
                name="locations"
                text={location}
                key={location}
                onChange={handleLocationsCheckboxChange}
                isChecked={checkedLocations.includes(location)}
            />
        );
    });

    return (
        <FormStep stepName="locations" onSubmit={onSubmit} formError={formError} validationSchema={validationSchema}>
            <Center>
                <Box w="788px" h="35rem">
                    <Stack>
                        <Heading fontSize="32px" fontWeight={800} width="800px">
                            Where are you interested in working?
                        </Heading>
                        <Text fontWeight={400} fontSize="15px" color="#686672">
                            Select all that apply.
                        </Text>
                        <Box>
                            <SimpleGrid
                                columns={2}
                                spacingX="38px"
                                spacingY={3}
                                mb={24}
                                h="100px"
                                alignSelf="center"
                            >
                                <CheckboxContainer name="compensation" h="48px">
                                    <Box align="right">{locationOptions1}</Box>
                                </CheckboxContainer>
                                <CheckboxContainer
                                    name="compensation"
                                    h="48px"
                                    alignItems="left"
                                    ml="-24px"
                                >
                                    <Box align="left">{locationOptions2}</Box>
                                </CheckboxContainer>
                            </SimpleGrid>
                        </Box>
                    </Stack>
                </Box>
            </Center>
        </FormStep>
    );
}
